// Constants.

// Allowed extensions for input file.
export const allowedExtensions = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

// Required csv header to parse data.
export const requiredHeadersForBulkEdit = ['id', 'employee_id', 'first_name', 'last_name', 'mobile_prefix', 'mobile', 'address', 'local_part',
    'designation', 'active', 'email_other', 'two_fa_enabled', 'mailarchive', 'is_hybrid', 'spam_filter_bypass', 'enable_access_restriction',
    'disable_password_expiration', 'allocated_space', 'is_domain_admin', 'domain_id', 'domain_name', 'policy_id', 'access_restriction_master_id',
    'incoming_connector_id', 'outgoing_connector_id', 'password', 'country_info', 'department_id', 'phone'];

export const requiredHeadersForBulkCreate = ['employee_id', 'first_name', 'last_name', 'mobile_prefix', 'mobile', 'address', 'local_part',
    'designation', 'active', 'email_other', 'two_fa_enabled', 'mailarchive', 'is_hybrid', 'spam_filter_bypass', 'enable_access_restriction',
    'disable_password_expiration', 'allocated_space', 'is_domain_admin', 'domain_id', 'domain_name', 'policy_id', 'access_restriction_master_id',
    'incoming_connector_id', 'outgoing_connector_id', 'password', 'country_info', 'department_id', 'phone'];

// CSV import key points to show in page
export const keyPoints = [
    'If you use CSV file then file must be in comma-separated values (.csv) format.',
    'The first row should include all required column names exactly as listed in the sample file without any extra spaces or characters at either end.',
    'All fields should be correctly filled according to their respective formats (e.g., email_other should be properly formatted).',
    'Any incorrectly formatted rows will be skipped during upload; users will receive feedback on which lines were not processed successfully.'
];

export const createUserKeypoints = [
    'If you use the CSV file then CSV file should be comma separated.(.csv)',
    "In import domain_id and domain_name are required. Click the 'GET DOMAIN_ID AND DOMAIN_NAME' button to retrieve this information.",
    'The first row should include all required column names exactly as listed in the sample file without any extra spaces or characters at either end.'
];

export const checkBoxStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    margin: '0 auto'
};


export const boxStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: 2
};


export const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    width: '95%',
    margin: '0 auto',
    // padding: '1rem',
    boxShadow: 3
};

export const sampleBulkCreateData = [
    {
        'employee_id': null, 'first_name': 'test209', 'last_name': 'testingking.com', 'phone': null,
        'mobile_prefix': 91, 'mobile': '9876543210', 'address': 'Banglore', 'local_part': 'test209', 'designation': 'IT Head',
        'active': true, 'email_other': null, 'two_fa_enabled': false, 'mailarchive': false,
        'is_hybrid': false, 'spam_filter_bypass': false, 'enable_access_restriction': false,
        'disable_password_expiration': false, 'allocated_space': 0.1, 'is_domain_admin': false,'department_id': 32,
        'domain_id': 1050, 'domain_name': 'testingking.com', 'policy_id': null, 'access_restriction_master_id': null,
        'incoming_connector_id': null, 'outgoing_connector_id': null, 'password': 'aBcd@422', 'country_info': [1, 2, 5]
    },
    {
        'employee_id': null, 'first_name': 'test210', 'last_name': 'testingking.com','phone': null,
        'mobile_prefix': 91, 'mobile': '9876543210', 'address': 'Banglore', 'local_part': 'test210', 'designation': 'IT Head',
        'active': true, 'email_other': null, 'two_fa_enabled': false, 'mailarchive': false,
        'is_hybrid': false, 'spam_filter_bypass': false, 'enable_access_restriction': false,
        'disable_password_expiration': false, 'allocated_space': 0.1, 'is_domain_admin': false,'department_id': 23,
        'domain_id': 1050, 'domain_name': 'testingking.com', 'policy_id': null, 'access_restriction_master_id': null,
        'incoming_connector_id': null, 'outgoing_connector_id': null, 'password': 'abCdeF@541', 'country_info': [1, 2, 5]
    },
];

export const sampleBulkEditData = [
    {
        'id': 139739, 'employee_id': null, 'first_name': 'test209', 'last_name': 'testingking.com', 'phone': null,
        'mobile_prefix': 91, 'mobile': '9876543210', 'address': 'Banglore', 'local_part': 'test209', 'designation': 'IT Head',
        'active': true, 'email_other': null, 'two_fa_enabled': false, 'mailarchive': false,
        'is_hybrid': false, 'spam_filter_bypass': false, 'enable_access_restriction': false,
        'disable_password_expiration': false, 'allocated_space': 0.1, 'is_domain_admin': false,'department_id': 32,
        'domain_id': 1050, 'domain_name': 'testingking.com', 'policy_id': null, 'access_restriction_master_id': null,
        'incoming_connector_id': null, 'outgoing_connector_id': null, 'password': null, 'country_info': [1, 2, 5]
    },
    {
        'id': 139740, 'employee_id': null, 'first_name': 'test210', 'last_name': 'testingking.com', 'phone': null,
        'mobile_prefix': 91, 'mobile': '9876543210', 'address': 'Banglore', 'local_part': 'test210', 'designation': 'IT Head',
        'active': true, 'email_other': null, 'two_fa_enabled': false, 'mailarchive': false,'department_id': 23,
        'is_hybrid': false, 'spam_filter_bypass': false, 'enable_access_restriction': false,
        'disable_password_expiration': false, 'allocated_space': 0.1, 'is_domain_admin': false,
        'domain_id': 1050, 'domain_name': 'testingking.com', 'policy_id': null, 'access_restriction_master_id': null,
        'incoming_connector_id': null, 'outgoing_connector_id': null, 'password': 'abCdeF@541', 'country_info': [1, 2, 5]
    }
];